import { TypeKeys } from '.';
import { Capacitor } from '@capacitor/core';
import { fst as firestore } from '../global/firebase';
import SworkitMobile from '../global/sworkit-mobile/sw-mobile';
import { doc, getDoc } from 'firebase/firestore';

export interface SetVolume {
  type: TypeKeys.SET_VOLUME;
  volume: number;
}

export const setVolume = (volume: number) => async (dispatch, _getState) => {
  const action: SetVolume = {
    type: TypeKeys.SET_VOLUME,
    volume,
  };
  return dispatch(action);
};

export interface SetMute {
  type: TypeKeys.SET_MUTE;
  muted: boolean;
}

export const setMute = (muted: boolean) => async (dispatch, _getState) => {
  const action: SetMute = {
    type: TypeKeys.SET_MUTE,
    muted,
  };
  return dispatch(action);
};

export interface SetAudioDucking {
  type: TypeKeys.SET_AUDIO_DUCKING;
  duckBackgroundAudio: boolean;
}

export function setAudioDuckingAction(duckBackgroundAudio: boolean) {
  const action: SetAudioDucking = {
    type: TypeKeys.SET_AUDIO_DUCKING,
    duckBackgroundAudio,
  };
  return action;
}

export const setAudioDucking = (duckBackgroundAudio: boolean) => async (
  dispatch,
  _getState
) => {
  try {
    await SworkitMobile.duckAudioToggle({ duck: duckBackgroundAudio });
    dispatch(setAudioDuckingAction(duckBackgroundAudio));
  } catch (err) {
    console.error(err);
  }
};

export const setInitialAudioDucking = () => async (dispatch, getState) => {
  if (Capacitor.isNativePlatform()) {
    try {
      const {
        localSettings: { duckBackgroundAudio },
      } = getState() as SworkitState;
      await SworkitMobile.duckAudioToggle({ duck: duckBackgroundAudio });
      return dispatch(setAudioDuckingAction(duckBackgroundAudio));
    } catch (err) {
      console.error('error setting audio ducking');
    }
  }
};

export const getMusicPlaylists = () => async (dispatch, _getState) => {
  if (!firestore) return;
  try {
    const musicDoc = await getDoc(doc(firestore, '/options/music'))
    const music = musicDoc.data();
    const playlists = music.stations as MusicPlaylist[];
    return dispatch(setMusicPlaylists(playlists));
  } catch (err) {
    console.error('error setting music playlists:', err);
  }
};

export interface SetMusicPlaylists {
  type: TypeKeys.SET_MUSIC_PLAYLISTS;
  musicPlaylists: MusicPlaylist[];
}

function setMusicPlaylists(musicPlaylists: MusicPlaylist[]) {
  const action: SetMusicPlaylists = {
    type: TypeKeys.SET_MUSIC_PLAYLISTS,
    musicPlaylists,
  };
  return action;
}

export interface SetMySworkit {
  type: TypeKeys.SET_MY_SWORKIT;
  mySworkit: SworkitState['localSettings']['mySworkit'];
}

export const setMySworkit = (
  mySworkit: SworkitState['localSettings']['mySworkit']
) => async (dispatch, _getState) => {
  const action: SetMySworkit = {
    type: TypeKeys.SET_MY_SWORKIT,
    mySworkit,
  };
  return dispatch(action);
};

export interface SetVoiceCommands {
  type: TypeKeys.SET_VOICE_COMMANDS;
  voiceCommandsEnabled: boolean;
}

export const setVoiceCommands = (voiceCommandsEnabled: boolean) => async (
  dispatch,
  _getState
) => {
  const action: SetVoiceCommands = {
    type: TypeKeys.SET_VOICE_COMMANDS,
    voiceCommandsEnabled,
  };
  return dispatch(action);
};

export interface DismissPtDisclaimer {
  type: TypeKeys.DISMISS_PT_DISCLAIMER;
}
export const dismissPtDisclaimer = () => (dispatch, _getState) => {
  const action: DismissPtDisclaimer = {
    type: TypeKeys.DISMISS_PT_DISCLAIMER,
  };
  return dispatch(action);
};

export interface DismissMSKDisclaimer {
  type: TypeKeys.DISMISS_MSK_DISCLAIMER;
}

export const dismissMSKDisclaimer = () => (dispatch, _getState) => {
  const action: DismissMSKDisclaimer = {
    type: TypeKeys.DISMISS_MSK_DISCLAIMER,
  };
  return dispatch(action);
};
export interface IncreaseLaunchCount {
  type: TypeKeys.INCREASE_LAUNCH_COUNT;
}

export const increaseLaunchCount = () => (dispatch, _getState) => {
  const action: IncreaseLaunchCount = {
    type: TypeKeys.INCREASE_LAUNCH_COUNT,
  };
  return dispatch(action);
};
